<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/hexagonia.png">
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";
import { redirectToUesPortals } from "@/utils/uesPortalsRedirect";

export default {
  name: "Hexagonia",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8',
      userData: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      console.log('gelen userData', this.userData)
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('Hexagonia SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/hexagonia/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/hexagonia/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.goHexagonia()
            } else if (response.data.message) {
              // success:false + message → örn. lisans/yetki reddi. Kullanıcı henüz
              // yok diye create'e düşmek yerine reddi doğrudan gösteriyoruz, çünkü
              // create de aynı kontrolden geçip aynı sebeple reddedilecek.
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/hexagonia/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/hexagonia/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.goHexagonia()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goHexagonia() {
      // Kurum öğrenci/öğretmen ayrımını kendi tarafında yapmıyorsa öğretmen de bu uca
      // (öğrenci sitesi) düşebiliyor — bu durumda Hexagonia'nın kendi sitesi yerine
      // UESPortals'a yönlendiriyoruz (bkz. utils/uesPortalsRedirect.js).
      if (this.userData.role_type === 'teacher') {
        redirectToUesPortals(this.userData, this.secretKey);
        return;
      }

      const studentData = {
        school_id: this.userData.school_id,
        campus_id: this.userData.campus_id,
        campus_name: this.userData.campus_name,
        first_name: this.userData.first_name,
        last_name: this.userData.last_name,
        username: this.userData.username,
        roleType: this.userData.role_type,
        password: this.userData.password,
        class: this.userData.class[0].grade,
        branch: this.userData.class[0].branch
      }
      const textJson = JSON.stringify(studentData);
      const uriText = decodeURIComponent(textJson)
      const ciphertext = CryptoJS.AES.encrypt(uriText, this.secretKey).toString();

      location.href = "https://www.hexagonia.com.tr/?sso=" + btoa(ciphertext);
    },

  }
}
</script>
